function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { j as l } from "./index.es33.js";
import { useState as f } from "react";
var j = function j(_ref) {
  var t = _ref.rowHeight,
    s = _ref.totalItems,
    e = _ref.items,
    r = _ref.visibleItemsLength,
    c = _ref.containerHeight;
  var _f = f(0),
    _f2 = _slicedToArray(_f, 2),
    n = _f2[0],
    i = _f2[1],
    a = t * s,
    o = Math.ceil(n / t),
    m = e === null || e === void 0 ? void 0 : e.slice(o, o + r),
    d = o * t,
    p = function p(x) {
      var _x$currentTarget;
      i(x === null || x === void 0 || (_x$currentTarget = x.currentTarget) === null || _x$currentTarget === void 0 ? void 0 : _x$currentTarget.scrollTop);
    };
  return l.jsx("div", {
    style: {
      maxHeight: c,
      overflow: "auto"
    },
    onScroll: p,
    children: l.jsx("div", {
      style: {
        minHeight: a
      },
      children: l.jsx("div", {
        style: {
          transform: "translateY(".concat(d, "px)")
        },
        children: m
      })
    })
  });
};
export { j as VirtualScroll };